import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { IconModalDialog } from 'core-components/library/common'
import { Flex } from 'core-components/library/flex'

interface IWidgetIconButton {
  iconClass?: string
  onChangeField: (field: string, value: any) => void
}

export const WidgetIconButton = ({ iconClass, onChangeField }: IWidgetIconButton) => {
  const [iconDialog, setIconDialog] = useState<boolean>(false)

  return (
    <>
      <Flex flexShrink={0}>
        <Button icon={iconClass} variant={'outlined'} onClick={() => setIconDialog(true)}>
          Icon
        </Button>
      </Flex>
      <IconModalDialog
        visible={iconDialog}
        onClose={() => setIconDialog(false)}
        onChange={(value: string) => onChangeField('iconClass', value)}
      />
    </>
  )
}
